var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#2D3D95",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2368 4259 c-795 -61 -1493 -531 -1966 -1324 -84 -142 -182 -343 -182 -375 0 -30 88 -215 166 -348 390 -666 942 -1115 1578 -1283 356 -94 776 -98 1141 -12 625 147 1174 567 1575 1205 84 134 220 404 220 437 0 31 -87 214 -166 349 -393 671 -955 1126 -1593 1287 -137 34 -256 53 -411 65 -150 11 -206 11 -362 -1z m390 -430 c675 -73 1244 -482 1627 -1167 l57 -102 -52 -92 c-361 -643 -893 -1054 -1500 -1159 -611 -105 -1212 82 -1674 521 -173 163 -370 423 -490 643 l-47 87 52 92 c303 542 745 933 1233 1093 248 81 539 112 794 84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2385 3395 c-305 -69 -540 -281 -637 -575 -26 -81 -31 -114 -35 -225 -6 -148 6 -222 56 -350 41 -107 100 -195 190 -286 168 -167 364 -249 601 -249 237 0 433 82 601 249 167 168 249 364 249 601 0 237 -82 433 -249 601 -123 123 -264 200 -431 235 -82 17 -266 17 -345 -1z m321 -436 c189 -71 306 -266 275 -460 -38 -233 -257 -396 -482 -360 -233 38 -396 257 -360 482 36 224 235 382 456 362 33 -3 83 -14 111 -24z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.94eb9d0e44a0b088a7d2586fb34e46d9.svg";
export { ForwardRef as ReactComponent };